import React from "react";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import StartupJourney from "@/sections/StartupJourney";
import FinalCTA from "@/sections/FinalCTA";
import Seo from "@/components/Seo";
import { AlertOctagon, Wallet, Users2, TrendingDown, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const mistakes = [
 { icon: Wallet, t: "Choosing on price alone", d: "The ₹999 sticker hides poor structure decisions that cost lakhs later." },
 { icon: AlertOctagon, t: "Wrong business structure", d: "OPC when you needed PVT. LTD.. LLP when you needed a Section 8. Structure is destiny." },
 { icon: Users2, t: "Skipping founder agreements", d: "No cap-table, no vesting, no founder agreement a fast recipe for cofounder pain." },
 { icon: TrendingDown, t: "Ignoring compliance calendars", d: "Missed ROC filings and GST returns quietly damage your business credit and reputation." },
];

export default function FirstTimeFoundersPage() {
 return (
 <div data-testid="page-first-time-founders">
 <Seo
  title="First-Time Founders Guide for Indian Startups"
  description="Honest guidance for first-time founders in India: structure, compliance, launch and presence. Written for real founders taking real first steps."
  path="/first-time-founders"
  breadcrumbs={[
    { name: "Home", path: "/" },
    { name: "First-Time Founders", path: "/first-time-founders" },
  ]}
 />
 <PageHero
 eyebrow="First-Time Founders"
 title="An honest guide for the first time you build something of your own."
 subtitle="This is where you find the answers no one gave you structure, compliance, launch, presence. Written for real Indian founders taking real first steps."
 image="https://images.unsplash.com/photo-1553877522-43269d4ea984?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80"
 />

 <section className="bg-white">
 <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20">
 <Reveal>
 <h2 className="font-display text-[32px] md:text-[44px] font-black leading-[1.05] text-[#0F1115]">
 Common mistakes we help you <span className="hl-yellow">avoid</span>.
 </h2>
 </Reveal>
 <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
 {mistakes.map((m, i) => {
 const Icon = m.icon;
 return (
 <Reveal delay={i * 80} key={m.t}>
 <div className="bg-white border border-[#EAEAEA] rounded-2xl p-7 flex flex-col items-center text-center h-full">
 <div className="w-12 h-12 rounded-full bg-[#FFF9E6] flex items-center justify-center">
 <Icon size={20} className="text-[#0F1115]" />
 </div>
 <h3 className="mt-5 font-display font-bold text-[20px] text-[#0F1115]">{m.t}</h3>
 <p className="mt-2 text-[15px] text-[#1C1F26] leading-relaxed max-w-sm">{m.d}</p>
 </div>
 </Reveal>
 );
 })}
 </div>
 </div>
 </section>

 <StartupJourney />

 <section className="bg-white border-t border-[#EAEAEA]">
 <div className="max-w-[1024px] mx-auto px-5 md:px-8 py-20 text-center">
 <Reveal>
 <h2 className="font-display text-[32px] md:text-[44px] font-black leading-[1.05] text-[#0F1115]">
 Ready for a 15-minute conversation?
 </h2>
 <p className="mt-4 text-[16px] md:text-[17px] text-[#1C1F26]">
 We'll help you name the real question you're trying to answer.
 </p>
 <Link
 to="/contact"
 className="mt-8 inline-flex items-center gap-2 bg-[#0F1115] text-white rounded-full px-7 py-3.5 font-bold text-[15px] hover:bg-[#1c1f26] transition-colors"
 data-testid="ftf-book-consultation"
 >
 Book your consultation <ArrowRight size={16} />
 </Link>
 </Reveal>
 </div>
 </section>

 <FinalCTA />
 </div>
 );
}
